<script>
import resources from './resources'

export default {
  name: 'gadget-agenda-statistics',

  mixins: [resources]
}
</script>

<template lang="pug">
  section.gadget-agenda-estatisticas.white-bg.wrapper.full-width.gadget(v-if="ishidden")
    .gadget-title
      | Estatísticas das Agendas
    .actions
      span.icon 
      ul
        li.exclude Remover
        li.half-width Lado a Lado
        li.full-width Tela Inteira
    div(v-for="agenda in agendas", :key="agenda.id")
      .col-xs-12.col-sm-2.col-md-2
        label.light-red Agenda
        h4.medium-gray {{ agenda.name }}
      .col-xs-12.col-sm-2.col-md-2
        label.light-red Validade
        h4.medium-gray {{ agenda.valid }}
      .col-xs-12.col-sm-2.col-md-2
        label.light-red Regras
        h4.medium-gray {{ agenda.rules }}
      .col-xs-12.col-sm-2.col-md-2
        label.light-red Eventos Disponíveis
        h4.medium-gray {{ agenda.available }}
      .col-xs-12.col-sm-2.col-md-4
        label.light-red Situação da Agenda
        .percentage-graph
          // Base
          .base
            .text {{ agenda.completed }}% Preenchida
          // Cor
          .color(:style="'width:' + agenda.completed + '%;'")
            .text
              | {{ agenda.completed }}% Preenchida
      .clearfix
</template>



// WEBPACK FOOTER //
// src/app/team/dashboard/gadget/components/agendas-statistics/agenda-statistics.vue